// frontend/src/pages/Dashboard/TargetAnalytics/index.jsx
import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import styles from './TargetAnalytics.module.css';
import BrandwiseAnalysis from './components/BrandwiseAnalysis';
import PercentageAnalysis from './components/PercentageAnalysis';

const TargetAnalytics = () => {
  const [activeTab, setActiveTab] = useState('percentage');
  const { sidebarOpen } = useOutletContext();

  const tabs = [
    { id: 'percentage', label: 'Percentage Analysis' },
    { id: 'brandwise', label: 'Brandwise Target Analysis' }
  ];

  return (
    <div className={`${styles.container}`}>
      <div className={styles.content}>
        <div className={styles.header}>
          <h1 className={styles.title}>Target Analytics</h1>
        </div>

        <div className={styles.tabContainer}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`${styles.tabButton} ${activeTab === tab.id ? styles.tabButtonActive : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className={styles.contentCard}>
          {activeTab === 'percentage' && <PercentageAnalysis />}
          {activeTab === 'brandwise' && <BrandwiseAnalysis />}
        </div>
      </div>
    </div>
  );
};

export default TargetAnalytics;